<template>
  <v-dialog v-model="dialog" lazy width="854">
    <v-card>
      <v-toolbar dense color="primary" dark>
        <v-toolbar-title>
          {{
            town._id
              ? $t('titles.global.updateModel', { field: $tc('models.town') })
              : $t('titles.global.newAModel', { field: $tc('models.town') })
          }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn dark icon @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap>
          <v-flex d-flex xs12 px-2>
            <translation-field
              ref="name"
              v-model="town.name"
              :label="$t('fields.global.name')"
            />
          </v-flex>

          <v-flex md6 xs12 px-2>
            <ProvinceField
              v-model="town.provinceId"
              v-validate="'required'"
              clearable
              :label="
                $t('action.actions.select', { field: $tc('models.province') })
              "
              autocomplete="new-text"
              browser-autocomplete
              :data-vv-name="$tc('models.province')"
              :error-messages="errors.collect($tc('models.province'))"
            />
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-switch
              v-model="town.active"
              :label="$t('fields.global.active')"
              color="primary"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <span style="color: red">(*) &nbsp;</span>
        <span>{{ $t('action.messages.fieldRequired') }}</span>
        <v-spacer />
        <meta-button type="reset" :disabled="loading" @click="clear" />
        <meta-button
          v-if="!town._id"
          type="create"
          :loading="loading"
          @click="submit()"
        />
        <meta-button
          v-else
          type="update"
          :loading="loading"
          @click="submit()"
        />
        <meta-button type="cancel" @click="cancel" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ProvinceField from '@/components/widgets/Input/ProvinceField'
import TranslationField from '@/components/widgets/Input/TranslationField'
import { parseObject } from '@/helpers/utils'

export default {
  name: 'TownForm',
  components: {
    TranslationField,
    ProvinceField,
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      town: {},
    }
  },
  watch: {
    dialog(val) {
      if (!val) this.cancel()
    },
    selected: {
      handler: function (val) {
        if (val) this.town = parseObject(val)
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.town = parseObject(this.selected)
  },
  computed: {
    ...mapState({
      selected: (state) => state.towns.selected,
      loading: (state) => state.towns.loading,
    }),
  },
  methods: {
    ...mapActions({
      setCreate: 'towns/create',
      setUpdate: 'towns/update',
      reset: 'towns/reset',
    }),
    submit() {
      Promise.all([this.validate(), this.$refs.name.validate()]).then(
        (valid) => {
          if (valid.some((valid) => !valid)) return

          let payload = Object.assign({}, this.town)
          if (!payload._id) {
            this.setCreate(payload).then((_) => {
              this.cancel()
            })
          } else {
            this.setUpdate(payload).then((_) => {
              this.cancel()
            })
          }
        }
      )
    },
    cancel() {
      this.clear()
      this.$emit('close')
    },
    clear() {
      this.reset()
      this.$validator.reset()
    },
  },
}
</script>
